import { ColumnAlignment, ColumnColoringMode, ColumnTotalVisibility } from '../TableColumn.interface';
export var StatementTableColumnId;
(function (StatementTableColumnId) {
    StatementTableColumnId["Account"] = "account";
    StatementTableColumnId["Symbol"] = "symbol";
    StatementTableColumnId["Date"] = "date";
    StatementTableColumnId["OperationType"] = "operationType";
    StatementTableColumnId["OperationId"] = "operationId";
    StatementTableColumnId["Amount"] = "amount";
    StatementTableColumnId["OpenPrice"] = "openPrice";
    StatementTableColumnId["ClosePrice"] = "closePrice";
    StatementTableColumnId["Quantity"] = "quantity";
    StatementTableColumnId["Currency"] = "currency";
    StatementTableColumnId["PosOpeningDate"] = "posOpeningDate";
    StatementTableColumnId["PositionId"] = "positionId";
    StatementTableColumnId["TradeId"] = "tradeId";
    StatementTableColumnId["Details"] = "details";
})(StatementTableColumnId || (StatementTableColumnId = {}));
;
function getColumnSortingInfo(id) {
    switch (id) {
        case StatementTableColumnId.Account:
            return { groupIndex: 1, index: 0 };
        case StatementTableColumnId.Symbol:
            return { groupIndex: 1, index: 1 };
        case StatementTableColumnId.Date:
            return { groupIndex: 1, index: 2 };
        case StatementTableColumnId.OperationType:
            return { groupIndex: 1, index: 3 };
        case StatementTableColumnId.OperationId:
            return { groupIndex: 1, index: 4 };
        case StatementTableColumnId.Amount:
            return { groupIndex: 1, index: 5 };
        case StatementTableColumnId.OpenPrice:
            return { groupIndex: 1, index: 6 };
        case StatementTableColumnId.ClosePrice:
            return { groupIndex: 1, index: 7 };
        case StatementTableColumnId.Quantity:
            return { groupIndex: 1, index: 8 };
        case StatementTableColumnId.Currency:
            return { groupIndex: 1, index: 9 };
        case StatementTableColumnId.PosOpeningDate:
            return { groupIndex: 1, index: 10 };
        case StatementTableColumnId.PositionId:
            return { groupIndex: 1, index: 11 };
        case StatementTableColumnId.TradeId:
            return { groupIndex: 1, index: 12 };
        default:
            return undefined;
    }
}
;
export function createStatementTableColumns() {
    const columns = [
        {
            id: StatementTableColumnId.Account,
            localizationKey: 'panel.statement.Account',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 75,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.Account)
        },
        {
            id: StatementTableColumnId.Symbol,
            localizationKey: 'panel.statement.Instrument',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 75,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.Symbol)
        },
        {
            id: StatementTableColumnId.Date,
            localizationKey: 'panel.statement.Date',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.Date)
        },
        {
            id: StatementTableColumnId.OperationType,
            localizationKey: 'panel.statement.Operation_type',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.OperationType)
        },
        {
            id: StatementTableColumnId.OperationId,
            localizationKey: 'panel.statement.Operation_ID',
            visible: true,
            alignment: ColumnAlignment.Left,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.OperationId)
        },
        {
            id: StatementTableColumnId.Amount,
            localizationKey: 'panel.statement.Amount',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.Signed,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.All,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.Amount)
        },
        {
            id: StatementTableColumnId.OpenPrice,
            localizationKey: 'panel.statement.Open_price',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.OpenPrice)
        },
        {
            id: StatementTableColumnId.ClosePrice,
            localizationKey: 'panel.statement.Close_price',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.ClosePrice)
        },
        {
            id: StatementTableColumnId.Quantity,
            localizationKey: 'panel.statement.Quantity',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.Overall,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.Quantity)
        },
        {
            id: StatementTableColumnId.Currency,
            localizationKey: 'panel.statement.Currency',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.Currency)
        },
        {
            id: StatementTableColumnId.PosOpeningDate,
            localizationKey: 'panel.statement.Trade_opening_date',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.PosOpeningDate)
        },
        {
            id: StatementTableColumnId.PositionId,
            localizationKey: 'panel.statement.positionID',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: true,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.PositionId)
        },
        {
            id: StatementTableColumnId.TradeId,
            localizationKey: 'panel.statement.tradeID',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.TradeId)
        },
        {
            id: StatementTableColumnId.Details,
            localizationKey: 'panel.statement.details',
            visible: true,
            alignment: ColumnAlignment.Center,
            coloringMode: ColumnColoringMode.None,
            defaultWidth: 70,
            isAllowGrouping: false,
            totalVisibility: ColumnTotalVisibility.None,
            sortingInfo: getColumnSortingInfo(StatementTableColumnId.Details)
        },
    ];
    const columnIds = Object.values(StatementTableColumnId);
    columns.sort((a, b) => columnIds.indexOf(a.id) - columnIds.indexOf(b.id));
    return columns;
}
;
